<template>
  <div>
    <v-toolbar flat color="primary">
      <v-title >
        MINI STATEMENT
        <span class="caption d-flex justify-start ml-3">{{
        this.selectedcustomer.PARTYMST_DESC
      }}</span>
      </v-title>
      <v-progress-circular
          v-if="loading"
          indeterminate
          color="white"
          class="d-flex justify-center align-center"
        ></v-progress-circular>
        <v-spacer></v-spacer>
        <v-btn icon  @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar> 
    <v-sheet color="white">

      <!-- <span class="h6 d-flex justify-center mr-7">MINI STATEMENT</span> -->
      <!-- <v-progress-linear
        color="primary"
        v-show="loading"
      ></v-progress-linear> -->
      
      <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Inv No
          </th>
          <th class="text-left">
            Date
          </th>
          <th class="text-left">
            Amount
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="invoice in customeroutstandingdocslist"
          :key="invoice.CUSTOUTS_DOCTYPE+invoice.CUSTOUTS_DOCNO"
        >
          <td>{{ invoice.CUSTOUTS_DOCNO }}</td>
          <td>{{ invoice.CUSTOUTS_DOCDATE }}</td>
          <td class="text-right">{{ invoice.CUSTOUTS_OUTSTANDING }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "Customerstatement",
  data() {
    return {};
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    selectedcustomer() {
      return this.$store.getters.thiscustomer;
    },
    customerdatalist() {
      return this.$store.getters.customerdata;
    },
    customeroutstandingdocslist() {
      return this.$store.getters.customeroutsdocs;
    },
  },
  methods:{
    closeDialog() {
      this.$emit('hideCustStmt');
    }
  },
  mounted() {
    console.log(this.customerdatalist);
    console.log(this.customeroutstandingdocslist);
  },
};
</script>

<style scoped></style>
